import React, { useEffect, useState, useMemo } from 'react'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Controllers from '../../Api/Controllers'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import ReactPlaceholder from 'react-placeholder'
import { FormCustom, Select } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'

const RankUp = () => {
  const [ready, setReady] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [rows, setRows] = useState([])
  const [periods, setPeriods] = useState([])
  const [periodSelected, setPeriodSelected] = useState('')

  useEffect(() => {
    Controllers.period.get_period().then(res => {
      setPeriods(res.data)
      setReady(true)
    })
  }, [])

  const handleSubmit = () => {
    setIsProcessing(true)
    Controllers.customers.get_rank_up({
      p_id_period: periodSelected
    }).then(res => {
      setRows(res.data)
    }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => setIsProcessing(false))
  }

  const dtTable = useMemo(() => <ReactDataTableBootstrap
    head={[
      [
        { name: 'id_customers', text: 'ID Cliente', align: 'center' },
        { name: 'full_name', text: 'Nombre Completo' },
        // { name: 'max_plan_previo', text: 'ID Rango Anterior', align: 'center' },
        { name: 'name_plan_previo', text: 'Rango Anterior', align: 'center' },
        // { name: 'plan_ultimo', text: 'ID Rango Actual', align: 'center' },
        { name: 'name_plan_actual', text: 'Rango Actual', align: 'center' },
        // { name: 'ultimo_periodo', text: 'Periodo', align: 'center' },
        { name: 'plan_points', text: 'Puntos Otorgados', align: 'center' },
      ]
    ]}
    rows={rows}
    isProcessing={isProcessing}
  />, [rows, isProcessing])

  return (
    <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
      <Card>
        <Card.Header>
          <span>Subes de Rango</span>
        </Card.Header>
        <Card.Body>
          <FormCustom viewSubmit={false}>
            <Select
              text="Período"
              classNameParent="col-12 mb-3"
              options={periods.map(p => ({
                label: p.name_period,
                value: p.id_period
              }))}
              onChange={e => setPeriodSelected(e.value)}
              append={[
                <Button onClick={handleSubmit}>
                  <i className="fa fa-search mr-2"></i>Buscar
                </Button>
              ]}
            />
          </FormCustom>
          {dtTable}
        </Card.Body>
      </Card>
    </ReactPlaceholder>
  )
}

export default RankUp
